import { render, staticRenderFns } from "./LegoRunTable.vue?vue&type=template&id=94ed7610&scoped=true&"
import script from "./LegoRunTable.vue?vue&type=script&lang=ts&"
export * from "./LegoRunTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ed7610",
  null
  
)

export default component.exports